import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "btn-group w-100",
  role: "group",
  "aria-label": "Does your final salary pension increase each year"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_button = _resolveComponent("radio-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "questionText" }, "Does this increase each year?", -1)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInflationItems(), (item, i) => {
        return (_openBlock(), _createBlock(_component_radio_button, {
          key: i,
          name: "inflation",
          label: item.text,
          value: _ctx.selectedValue,
          onChange: _ctx.changeValue
        }, null, 8, ["label", "value", "onChange"]))
      }), 128))
    ])
  ], 64))
}